import 'date-fns';
import React, { useRef } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {
    DatePicker as MaterialUIDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import CalendarDayIcon from 'components/library/Icons/CalendarDayIcon';
import { InputAdornment, TextField } from '@material-ui/core';
import composeClassNames from 'utils/composeClassNames';
import theme from 'utils/theme';
import { inputClasses } from '../TextInput/TextInput';
import './DatePicker.css';

function DatePicker({
    id,
    value,
    label,
    autoOk,
    onChange,
    minDate,
    maxDate,
    clearable = false,
}) {
    const anchorElRef = useRef();
    return (
        <MuiThemeProvider theme={theme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <MaterialUIDatePicker
                    disableToolbar
                    id={id}
                    autoOk={autoOk}
                    variant="dialog"
                    format="dd/MM/yyyy"
                    value={value}
                    label={label}
                    minDate={minDate}
                    maxDate={maxDate}
                    clearable={clearable}
                    TextFieldComponent={(props) => {
                        const labelClasses = {
                            root: 'Input__label',
                            shrink: 'Input__label--shrink',
                            focused: 'Input__label--focused',
                            disabled: 'Input__label--disabled',
                            error: 'DatePicker__label--error',
                        };
                        const classNames = composeClassNames([
                            'Input',
                            'TextInput',
                            props.className,
                        ]);
                        return (
                            <TextField
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...props}
                                ref={anchorElRef}
                                className={classNames}
                                margin="none"
                                variant="filled"
                                FormHelperTextProps={{
                                    classes: {
                                        error: 'DatePicker__FormHelperText--error',
                                    },
                                }}
                                InputProps={{
                                    classes: {
                                        ...inputClasses,
                                        error: 'DatePicker__Input--error',
                                    },
                                    startAdornment: (
                                        <InputAdornment
                                            classes={{ root: 'Input__prefix' }}
                                            position="start"
                                        >
                                            <CalendarDayIcon width={24} />
                                        </InputAdornment>
                                    ),
                                }}
                                InputLabelProps={{
                                    classes: labelClasses,
                                }}
                            />
                        );
                    }}
                    onChange={onChange}
                />
            </MuiPickersUtilsProvider>
        </MuiThemeProvider>
    );
}

export default DatePicker;
